'use strict';

module.exports = {
    'en-us': {
        items: 'items',
        item: 'item'
    },
    'zh-cn': {
        items: '项',
        item: '项'
    },
    'zh-tw': {
        items: '項',
        item: '項'
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@alife/next/lib/_components/@alife/next-transfer/lib/locale/index.js
// module id = 462
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11